export type PresetKey =
  | "hoy"
  | "semana_ultima"
  | "semana_actual"
  | "mes"
  | "mes_anterior"
  | "anio"
  | "anio_anterior"
  | "todo"
  | "custom";

export interface DateRange {
  date_from: string | null;
  date_to: string | null;
}

const iso = (d: Date) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

// "Ahora" en la zona horaria de México (CDMX), no en UTC
function mxNow(): Date {
  return new Date(new Date().toLocaleString("en-US", { timeZone: "America/Mexico_City" }));
}

// Lunes como inicio de semana
function startOfWeek(d: Date): Date {
  const x = new Date(d);
  const day = (x.getDay() + 6) % 7; // 0 = lunes
  x.setDate(x.getDate() - day);
  return x;
}

export function presetRange(key: PresetKey): DateRange {
  const now = mxNow();
  const y = now.getFullYear();
  const m = now.getMonth();
  switch (key) {
    case "hoy":
      return { date_from: iso(now), date_to: iso(now) };
    case "semana_actual": {
      const from = startOfWeek(now);
      return { date_from: iso(from), date_to: iso(now) };
    }
    case "semana_ultima": {
      const thisMon = startOfWeek(now);
      const lastMon = new Date(thisMon);
      lastMon.setDate(thisMon.getDate() - 7);
      const lastSun = new Date(thisMon);
      lastSun.setDate(thisMon.getDate() - 1);
      return { date_from: iso(lastMon), date_to: iso(lastSun) };
    }
    case "mes":
      return { date_from: iso(new Date(y, m, 1)), date_to: iso(new Date(y, m + 1, 0)) };
    case "mes_anterior":
      return { date_from: iso(new Date(y, m - 1, 1)), date_to: iso(new Date(y, m, 0)) };
    case "anio":
      return { date_from: iso(new Date(y, 0, 1)), date_to: iso(new Date(y, 11, 31)) };
    case "anio_anterior":
      return { date_from: iso(new Date(y - 1, 0, 1)), date_to: iso(new Date(y - 1, 11, 31)) };
    case "todo":
    default:
      return { date_from: null, date_to: null };
  }
}

export const PRESET_LABELS: { key: PresetKey; label: string }[] = [
  { key: "hoy", label: "Hoy" },
  { key: "semana_ultima", label: "Última semana" },
  { key: "semana_actual", label: "Esta semana" },
  { key: "mes", label: "Este mes" },
  { key: "mes_anterior", label: "Mes anterior" },
  { key: "anio", label: "Este año" },
  { key: "anio_anterior", label: "Año anterior" },
  { key: "todo", label: "Todo" },
  { key: "custom", label: "Personalizado" },
];

const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

function fmt(dateStr: string): string {
  const [y, m, d] = dateStr.split("-").map(Number);
  return `${d} ${MESES[m - 1]} ${y}`;
}

export function formatRange(r: DateRange): string {
  if (!r.date_from && !r.date_to) return "Todo el historial";
  if (r.date_from && r.date_to) {
    return r.date_from === r.date_to ? fmt(r.date_from) : `${fmt(r.date_from)} – ${fmt(r.date_to)}`;
  }
  return fmt((r.date_from || r.date_to) as string);
}

